import React, { useCallback, useState } from "react";
import Loader from "../../shared/Loader";
import StatementCard from "../../shared/StatementCard";
import ExcelPopupBtn from "./PopupBtns/ExcelPopupBtn";
import FilterDetailBar from "./PopupBtns/FilterDetailBar";
import AdvanceSearchBtn from "./PopupBtns/AdvanceSearchBtn";
import { useGetStatements } from "../../lib/queries/queriesAndMutations";
import Pagination from "../../shared/Pagination";
import { statementFieldLabels, withdrawsFields } from "../../lib/constants";
import { useDebounce } from "../../hooks/useDebounce";
import InformationTooltip from "../../ui/InformationTooltip";

const StatementsList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const [searchTerm, setSearchTerm] = useState({
    user_id: "",
  });

  const debouncedQueryParams = useDebounce(searchTerm, 1024);

  const onPageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const {
    data: statementsData,
    isPending,
    isRefetching,
  } = useGetStatements({
    debouncedQueryParams,
    currentPage,
  });

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex justify-center items-center min-h-[400px]">
        <Loader />
      </div>
    );
  }

  const hasResults = statementsData?.count > 0;

  return (
    <>
      <div className="figure-wrapper space-y-2">
        <div className="flex w-full gap-[10px] ">
          <InformationTooltip />
          <ExcelPopupBtn
            searchTermRef={searchTerm}
            fields={withdrawsFields}
            url="reports/statements"
          />
          <AdvanceSearchBtn setSearchTerm={setSearchTerm} />
        </div>
        <FilterDetailBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          labelFields={statementFieldLabels}
        />
      </div>
      <div className="figure-wrapper">
        {/* Results */}
        {hasResults ? (
          <div className="space-y-4 w-full">
            <div className="flex flex-col gap-2 w-full">
              {statementsData?.results.map((item, index) => (
                <StatementCard key={item.id} item={item} index={index} />
              ))}
            </div>
            {/* Pagination */}
            <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
              <Pagination
                onPageChange={onPageChange}
                totalCount={statementsData?.count || 0}
                siblingCount={1}
                currentPage={currentPage}
                pageSize={pageSize}
                className="bg-neutral-10"
              />
            </div>
          </div>
        ) : (
          <div className=" flex flex-col items-center p-6 rounded-md">
            <img
              src="/icons/shopping-pos-machine.svg"
              alt="no data"
              className="max-w-[40px] max-h-[40px] invert rounded-md p-1"
            />
            <p>پرداختی یافت نشد!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default StatementsList;
